<button
  pButton
  [label]="buttonLabel"
  [class]="buttonClass"
  [disabled]="disabled || jobCount === 0"
  (click)="openDialog()"
></button>

<p-dialog
  header="Queue for Auto Direct"
  [(visible)]="showDialog"
  [modal]="true"
  [style]="{ width: '450px' }"
  [closable]="!queuing"
>
  <p>
    <ng-container *ngIf="jobCount === 1">This job</ng-container>
    <ng-container *ngIf="jobCount > 1">These {{ jobCount }} jobs</ng-container>
    will be queued for auto direct and picked up in the
    <strong *ngIf="nextRun"
      >next scheduled batch run at {{ nextRun | datex : 'ddd DD MMM YYYY HH:mm' }}</strong
    >
    <strong *ngIf="!nextRun">next scheduled batch run</strong>.
  </p>
  <p-footer>
    <button
      pButton
      type="button"
      label="Cancel"
      class="ui-button-secondary"
      (click)="showDialog = false"
      [disabled]="queuing"
    ></button>
    <button
      pButton
      type="button"
      [label]="queuing ? 'Queuing...' : 'Confirm'"
      (click)="confirm()"
      [disabled]="queuing"
    ></button>
  </p-footer>
</p-dialog>
